import React, { Component } from "react";
import { connect } from "react-redux";
import Loading from "../Loading";
import { checkForStockWarningMessage } from "../Menu/Helpers";
import WhatshotIcon from "@material-ui/icons/Whatshot";
import ProductQuantity from "./ProductQuantity";
import ProductPrice from "./ProductPrice";
import {
  getDiscountedPrice,
  getProductDiscountAmount,
  isApplicableCategeoryPromo,
} from "../../Helpers/promotions";
import dairyFreeIcon from "../ActionButton/assests/no-milk.png";
import glutenFreeIcon from "../ActionButton/assests/gluten-free.png";
import sugarFreeIcon from "../ActionButton/assests/sugar-free.png";
import nutFreeIcon from "../ActionButton/assests/peanut-free.png";
import organicIcon from "../ActionButton/assests/bio_480.png";
import vegetarianIcon from "../ActionButton/assests/leaf.png";
import veganIcon from "../ActionButton/assests/vegan.png";
import glutenIcon from "../ActionButton/assests/gluten.png";
import nutsSesameIcon from "../ActionButton/assests/nuts_sesame.png";
import dairyIcon from "../ActionButton/assests/dairy.png";
import eggIcon from "../ActionButton/assests/egg.png";
import seafoodShellfishIcon from "../ActionButton/assests/seafood_shellfish.png";
import chilliIcon from "../ActionButton/assests/chilli.png";
import CircularProgress from "@material-ui/core/CircularProgress";

class ProductName extends Component {
  getUnit() {
    const { current_product, language } = this.props;
    if (!current_product.unit) return "";

    if (language === "arabic") {
      return `لكل ${current_product.unit.ar_name}`;
    }
    return `per ${current_product.unit.name}`;
  }
  NutritionalFacts() {
    const { current_product, language, settings } = this.props;
    if (
      !settings.show_nutrition_facts ||
      !settings.show_nutrition_facts_products
    )
      return;
    let nut_en = "";
    let nut_ar = "";
    if (current_product.calories && current_product.calories > 0) {
      nut_en = nut_en + `Calories ${current_product.calories}kcal / `;
      nut_ar =
        nut_ar + `السعرات الحرارية  ${current_product.calories} سعرة حرارية / `;
    }
    if (current_product.carbs && current_product.carbs > 0) {
      nut_en = nut_en + `Carbs ${current_product.carbs}g / `;
      nut_ar = nut_ar + `الكربوهيدرات ${current_product.carbs}  جم / `;
    }
    if (current_product.fats && current_product.fats > 0) {
      nut_en = nut_en + `Fats ${current_product.fats}g / `;
      nut_ar = nut_ar + `الدهون ${current_product.fats} جم / `;
    }
    if (current_product.protein && current_product.protein > 0) {
      nut_en = nut_en + `Protein ${current_product.protein}g`;
      nut_ar = nut_ar + `البروتين ${current_product.protein}  جم `;
    }

    if (language === "arabic") {
      return nut_ar;
    }
    return nut_en;
  }

  getAddedQuantity = (ignoreMaxQuantity = false) => {
    const editedProduct = this.props.location.state?.editedProduct;
    let addedQuantity = 0;
    if (this.props.current_product) {
      if (
        !ignoreMaxQuantity &&
        !this.props.current_product.max_addable_quantity
      )
        return 0;
      this.props.cart.forEach((product) => {
        if (product.id === this.props.current_product.id)
          addedQuantity += product.quantity;
      });
    }
    return addedQuantity - (editedProduct?.quantity || 0);
  };

  render() {
    if (!this.props.current_product) return <Loading />;
    const { current_product, language, settings } = this.props;

    const stockWarningMessage =
      current_product.type_of_product === "stocked" &&
      current_product.show_warning_item_availability &&
      !this.props.outOfStock &&
      current_product.inventory_on_hand <=
        current_product.warning_item_availability_count &&
      !current_product.has_variants;
    const message = () => {
      if (current_product.warning_item_availability_message_value === 0) {
        return language === "english" ? "Few items left !" : "متبقي القليل !";
      } else {
        return language === "english"
          ? `${current_product.inventory_on_hand} left`
          : ` متبقي ${current_product.inventory_on_hand} `;
      }
    };
    const editedProduct = this.props.location.state?.editedProduct;
    const prevState = this.props.location.state?.prevState;
    const preorderingMode =
      (this.props.outOfStock &&
        ["stocked", "composite"].includes(current_product.type_of_product) &&
        current_product.allow_preordering &&
        current_product.preorder_inventory > 0) ||
      editedProduct?.is_preordered;

    let addedQuantity = this.getAddedQuantity();
    return (
      <div
        className="border-top border-bottom "
        style={{
          backgroundColor: "white",
          lineHeight: "30px",
          minHeight: "45px",
        }}
      >
        <div style={{ marginTop: 5 }}>
          {this.props.fodooleLoading ? (
            <CircularProgress size={20} style={{ marginTop: 5 }} />
          ) : (
            <span
              className={"text-muted cut-text-one-line-product-name ".concat(
                language == "english" ? " mx-3 text-left" : " text-right",
              )}
              style={{
                direction: language == "arabic" ? "rtl" : "ltr",
                width: "97%",
                fontWeight: "bold",
              }}
            >
              {stockWarningMessage && (
                <>
                  <span
                    style={{
                      color: "red",
                      fontSize: 12,
                      fontFamily: "Quicksand, Cairo",
                      fontWeight: "bold",
                    }}
                  >
                    <WhatshotIcon
                      style={{
                        fontSize: 12,
                        marginBottom: 3,
                      }}
                    />{" "}
                    {message()}
                  </span>
                  {" - "}{" "}
                </>
              )}
              {language == "english"
                ? current_product.name
                : current_product.ar_name}
              {settings.show_nutrition_facts && (
                // <div
                //   className="ml-3"
                //   style={{
                //     textAlign:
                //       this.props.language === "arabic" ? "right" : "left",
                //     marginTop: -8,
                //   }}
                // >
                <span className="mx-2">
                  {current_product.dietary_restrictions?.includes(
                    "Dairy free",
                  ) && (
                    <img
                      src={dairyFreeIcon}
                      style={{ marginRight: 5, height: 17, width: 17 }}
                    />
                  )}
                  {current_product.dietary_restrictions?.includes(
                    "Gluten free",
                  ) && (
                    <img
                      src={glutenFreeIcon}
                      style={{ marginRight: 5, height: 17, width: 17 }}
                    />
                  )}
                  {current_product.dietary_restrictions?.includes(
                    "Sugar free",
                  ) && (
                    <img
                      src={sugarFreeIcon}
                      style={{ marginRight: 5, height: 17, width: 17 }}
                    />
                  )}
                  {current_product.dietary_restrictions?.includes(
                    "Nut free",
                  ) && (
                    <img
                      src={nutFreeIcon}
                      style={{ marginRight: 5, height: 17, width: 17 }}
                    />
                  )}
                  {current_product.dietary_restrictions?.includes("Vegan") && (
                    <img
                      src={veganIcon}
                      style={{ marginRight: 5, height: 17, width: 17 }}
                    />
                  )}
                  {current_product.dietary_restrictions?.includes(
                    "Vegetarian",
                  ) && (
                    <img
                      src={vegetarianIcon}
                      style={{ marginRight: 5, height: 17, width: 17 }}
                    />
                  )}
                  {current_product.dietary_restrictions?.includes(
                    "Organic",
                  ) && (
                    <img
                      src={organicIcon}
                      style={{ marginRight: 5, height: 17, width: 17 }}
                    />
                  )}
                  {current_product.dietary_restrictions?.includes("Gluten") &&
                    !current_product.dietary_restrictions?.includes(
                      "Gluten free",
                    ) && (
                      <img
                        src={glutenIcon}
                        style={{ marginRight: 5, height: 17.6, width: 17.6 }}
                      />
                    )}

                  {current_product.dietary_restrictions?.includes(
                    "Nuts/Sesame",
                  ) && (
                    <img
                      src={nutsSesameIcon}
                      style={{ marginRight: 5, height: 20, width: 20 }}
                    />
                  )}

                  {current_product.dietary_restrictions?.includes("Dairy") && (
                    <img
                      src={dairyIcon}
                      style={{ marginRight: 5, height: 20, width: 20 }}
                    />
                  )}

                  {current_product.dietary_restrictions?.includes("Egg") && (
                    <img
                      src={eggIcon}
                      style={{ marginRight: 5, height: 20, width: 20 }}
                    />
                  )}

                  {current_product.dietary_restrictions?.includes(
                    "Seafood/Shellfish",
                  ) && (
                    <img
                      src={seafoodShellfishIcon}
                      style={{ marginRight: 5, height: 21, width: 21 }}
                    />
                  )}

                  {current_product.dietary_restrictions?.includes("Chilli") && (
                    <img
                      src={chilliIcon}
                      style={{ marginRight: 5, height: 20, width: 20 }}
                    />
                  )}
                </span>
              )}
              {/* } */}
            </span>
          )}
        </div>
        {settings.show_nutrition_facts && this.NutritionalFacts() != "" && (
          <div>
            <span
              className={"product-nutrition".concat(
                language == "english" ? " mx-3 text-left" : " mx-3 text-right",
              )}
              style={{
                direction: language == "arabic" ? "rtl" : "ltr",
                color: "#999",
                marginTop: -7,
                fontSize: "12px",
              }}
            >
              {this.NutritionalFacts()}
            </span>
          </div>
        )}

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginTop: -7,
            flexDirection: language === "arabic" && "row-reverse",
          }}
        >
          <div>
            {!current_product.has_variants &&
              !current_product.hide_buy_button &&
              this.props.settings.show_prices && (
                <ProductPrice
                  price_with_discount={getDiscountedPrice(
                    current_product.price,
                    this.props.discountAmount,
                    null,
                    null,
                  )}
                />
              )}
          </div>
          <div>
            {current_product.hide_quantity_box ||
            (this.props.outOfStock && !preorderingMode) ||
            this.props.store.settings.quantity_box_location === "bottom" ||
            current_product.type_of_product == "service" ||
            this.props.store.settings.is_menu
              ? null
              : !this.props.current_product.has_variants && (
                  <ProductQuantity
                    addedQuantity={addedQuantity}
                    scrollToBookables={this.props.scrollToBookables}
                    SetQuantity={(quantity) => this.props.SetQuantity(quantity)}
                    booking_slot={
                      this.props.bookingslot ? this.props.bookingslot : -1
                    }
                    promo_items_addable_quantity={
                      this.props.promo_items_addable_quantity
                    }
                    preorderingMode={preorderingMode}
                    selectedOptions={this.props.options}
                    productUsedComponents={this.props.productUsedComponents}
                    editedProduct={editedProduct}
                    quantity={this.props.quantity}
                  />
                )}
          </div>
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    language: state.store.language,
    current_product: state.store.current_product,
    settings: state.store.store.settings,
    store: state.store.store,
    cart: state.cart.cart,
  };
};

export default connect(mapStateToProps)(ProductName);
